import React from 'react';
import { Pagination as AlgoliaPagination } from 'react-instantsearch';
export default function Pagination({ paginationSettings, pagination }) {
    const { pages, } = pagination;
    if (pages.length < 2) {
        return null;
    }
    return (React.createElement(AlgoliaPagination
    // Optional props
    , { 
        // Optional props
        totalPages: paginationSettings.totalPages, padding: paginationSettings.padding, showFirst: paginationSettings.showFirst, showPrevious: paginationSettings.showPrevious, showNext: paginationSettings.showNext, showLast: paginationSettings.showLast, classNames: paginationSettings.classNames, translations: paginationSettings.translations }));
}
